// Centralized endpoint/environment logic for SnapSuite Saturn API

// Determine environment (development or production)
let isDevEnv = false;
if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') {
  isDevEnv = true;
} else if (typeof window !== 'undefined' && window.location && window.location.href.includes('https://dev.jupiter.pages.dev')) {
  isDevEnv = true;
}

export const baseSaturnApiUrl = 'https://saturn.snapsuite.io/api/';
export const isDev = isDevEnv;

// UX API Configuration
export const uxApiUrl = 'https://ux.snapsuite.io/api/';

// Feature flags for endpoint routing
export const useNewUXEndpoint = true; // Set to false to use Saturn API for ux/dropdown

/**
 * Gets the appropriate URL for UX dropdown endpoints
 * @param endpoint - The endpoint path (e.g., 'ux/dropdown')
 * @returns The full URL for the endpoint
 */
export function getUXDropdownUrl(endpoint: string): string {
  if (useNewUXEndpoint) {
    return uxApiUrl + endpoint;
  }
  return baseSaturnApiUrl + endpoint;
}
